import React from "react"
import {
    Steps,
    Button,
    message,
    SuiNumber,
    SuiInput,
    SuiSelect,
    SuiForm,
} from "@sudy/sui-react"
// import optionsStore from './stores/optionsStore';
import optionsStore from "../../stores/optionsStore"
import { Result } from "antd"
import { observable } from "mobx"
import { observer } from "mobx-react"
import postStore from "../../stores/postStore"
import { $attrs } from "@sudy/sui-react/lib/sui/bind"
import apis from "../../util/urls"
import $ from "jquery";
import urls from "../../util/urls"

class SetOver extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 0,
            code: null,
            count: 4,
            show: 'none'
        }
    }

    handleBack = () => {
        this.setState({
            current: 0,
        })
    }

    toRcirection(){
        const { count, link } = this.state;
        if (count === 1) {
            // window.open(link);
            window.location.href = link;
            // window.location.replace(link)
        } else {
            this.setState({
                count: count - 1,
                over: false,
            });
            setTimeout(this.toRcirection.bind(this), 1000);
        }
    }

    /**
     * 获取跳转链接
     */
    getRedirectURL() {
        const _this = this;

        $.ajax({
            url: urls.getRedirectURL,
            type: "get",
            dataType: "json",
            success: function (response) {
                if (
                    response.resultCode === 0 &&
                    response.result.data 
                ) {
                    if(response.result.data.link !== ""){
                        // 倒计时跳转链接
                        _this.setState(
                            {
                                link: response.result.data.link,
                                show: "block",
                            },
                            () => _this.toRcirection()
                        )
                    }
                    
                } else {
                    message.warning(response.errorMsg)
                }
            },
            error: function (xhr) {
                // message.warning("请求异常")
            },
            complete: function () {},
        })
    }

    componentDidMount() {
        this.getRedirectURL()
    }

    render() {
        const { count, show } = this.state
        return (
            <div
                ref={(node) => {
                    this.setOverNode = node
                }}
            >
                <SuiForm bind={postStore}>
                    <Result
                        status="success"
                        title="账号激活完成"
                        subTitle=""
                        // extra={[
                        //     <Button type="primary" key="console">
                        //         进入自助服务
                        //     </Button>,
                        //     <Button
                        //         key="buy"
                        //         onClick={() => this.props.onClick()}
                        //     >
                        //         返回
                        //     </Button>,
                        // ]}
                    />

                    <div style={{textAlign: 'center',display:`${show}`}} >
                        页面即将跳转  
                        <span style={{fontSize:24,paddingLeft:15,fontWeight:600}}>{count}</span>
                    </div>
                </SuiForm>
            </div>
        )
    }
}
export default SetOver
